import React, { useEffect } from 'react'
import { ElementProps } from '../base/element'
import { IComponent, IDataComponent, IDefaultStyles, IStyles } from '../schemamanager/types'
import { EventType } from '../schemamanager/schemaManager'

export interface ICheckboxComponent extends IDataComponent {
  type: 'checkbox'
  label?: string
  styleInput?: IStyles
  styleLabel?: IStyles
}

export const Checkbox = (props: ElementProps) => {
  const { sm, themeColor, events, data, addProps } = props
  const comp = props.comp as ICheckboxComponent


  const ref: any = React.useRef()
  
  const defaultValue = data.value()
  const [editValue, setEditValue] = React.useState(defaultValue)

  const doFocus = (compToFocus: IComponent) => {
    if (compToFocus === comp) {
      ref.current?.focus()
    }
  }

  useEffect(() => {
    sm.on(EventType.FocusComponent, doFocus)
    return () => {
      sm.removeListener(EventType.FocusComponent, doFocus)
    }
  }, [sm])

  const handleChange = () => {
    const value = ref.current?.checked
    setEditValue(value)
    data.updateValue(value)

    if (events().onChange) {
      events().onChange({ sm, comp, value })
    }
  }

  const style: IDefaultStyles = {
    main: {
      classes: {
        margin: 'mt-3 mx-2',
        display: 'flex',
        alignItems: 'items-center'
      },
    },
    styleInput: {
      classes: {
        height: 'h-5',
        width: 'w-5',
        textColor: themeColor().textColor
      },
      class: 'disabled:opacity-50'
    },
    styleLabel: {
      classes: {
        margin: 'ml-2',
        textColor: 'text-gray-700'
      }
    },
  }

  const m = props.mergeStyles(style)

  return (
    <div {...m.main} {...events()}>
      <input
        ref={ref}
        type='checkbox'
        checked={editValue}
        onChange={handleChange}
        {...m.styleInput}
        {...addProps()}
      />
      <span {...m.styleLabel}>{comp.label}</span>
    </div>
  )
}
